module.exports = __webpack_public_path__ + "img/icon_instagram_trash.d3b71c83.svg";